import React from 'react';
import { InvoiceSummaryBucketFilter } from '@finance-hub/domain/invoicing/blocs/types/unpaid-invoice-filters';
import { InvoiceSummaryBucketsRow } from '@finance-hub/domain/invoicing/components/invoice-summary-buckets-row';
import { InvoiceSummaryBucketsRowSkeleton } from '@finance-hub/domain/invoicing/components/invoice-summary-buckets-row-skeleton';
import { useInvoiceSummaryLoader } from '@finance-hub/domain/invoicing/blocs/loaders/use-invoice-summary-loader';
import { useUnpaidInvoiceFilterStore } from '@finance-hub/domain/invoicing/blocs/stores/use-unpaid-invoice-filter-store';

export const InvoiceSummaryBucketsContainer: React.FC = () => {
  const { loading, summary } = useInvoiceSummaryLoader();
  const selectedBucketFilter = useUnpaidInvoiceFilterStore(
    (state) => state.selectedBucketFilter,
  );
  const clearBucketFilter = useUnpaidInvoiceFilterStore(
    (state) => state.clearBucketFilter,
  );
  const selectAgingBucket = useUnpaidInvoiceFilterStore(
    (state) => state.selectAgingBucket,
  );
  const selectCreditMemos = useUnpaidInvoiceFilterStore(
    (state) => state.selectCreditMemos,
  );

  const selectBucketFilter = (filter: InvoiceSummaryBucketFilter) => {
    switch (filter.kind) {
      case 'agingBucket':
        selectAgingBucket(filter.overdueBucket);
        return;
      case 'allInvoices':
        clearBucketFilter();
        return;
      case 'creditMemos':
        selectCreditMemos();
    }
  };

  if (summary) {
    return (
      <InvoiceSummaryBucketsRow
        onSelectFilter={selectBucketFilter}
        selectedFilter={selectedBucketFilter}
        summary={summary}
      />
    );
  }

  if (loading) {
    return <InvoiceSummaryBucketsRowSkeleton />;
  }

  return null;
};
